import { render, staticRenderFns } from "./RepaymentAmountDisplayCard.vue?vue&type=template&id=07155c79&scoped=true"
import script from "./RepaymentAmountDisplayCard.vue?vue&type=script&lang=js"
export * from "./RepaymentAmountDisplayCard.vue?vue&type=script&lang=js"
import style0 from "./RepaymentAmountDisplayCard.vue?vue&type=style&index=0&id=07155c79&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07155c79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07155c79')) {
      api.createRecord('07155c79', component.options)
    } else {
      api.reload('07155c79', component.options)
    }
    module.hot.accept("./RepaymentAmountDisplayCard.vue?vue&type=template&id=07155c79&scoped=true", function () {
      api.rerender('07155c79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/LoanDetails/components/RepaymentAmountDisplayCard.vue"
export default component.exports